/**
 * Query keys are used to identify the queries in the tanstack-query cache.
 * They are used to refetch, invalidate, and set data in the cache.
 **/
export enum queryKeysE {
  RETAILERS = 'retailers',
  RETAILER = 'retailer',
  RETAILERS_STATS = 'retailers_stats',
  // Add more query keys here...
  // Example:
  // USERS = 'users',
  // USER = 'user',
  // ORDERS = 'orders',
  // ORDER = 'order',
}
